module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-tips@2x.b9a5ba8e.jpg";